$(function (){
	var define_car_App={
      	
		init: function(){
			this.findByCarListner();
		},
		
      	  findByCarListner: function() {
			var _disable = function(data) { $(data).prop('disabled', true);}, year=$('#year_id_hero'),make=$('#make_id_hero'),model=$('#model_id_hero');
			year.change(function() {
				$('.wait_spinner1').remove();
				$('.wait_spinner2').remove();
				var year_id = $(this).val(),
                    spiner='<div class="wait_spinner1"><i class="fa fa-spinner fa-pulse fa-fw" aria-hidden="true"></i></div>';
				if (year_id == '0') {
					make.html('<option>2. - Select Make -</option>');
					_disable(make);
					model.html('<option>3. - Select Model -</option>');
					_disable(model);
					_disable(fndButton);
					return (false);}
					_disable(make);
					make.html('<option>Loading...</option>');
					make.after(spiner);
					var url = 'https://www.kensunhid.com/promo_page/car_filter/get_make.php';
					$.get(
						url,
						"year_id=" + year_id,
						function(result) {
							if (result.type == 'error') {
								alert('error');
								return (false);
							} else {
								$('.wait_spinner1').remove();
								var options = '';
								$(result.makes).each(function() {
									options += '<option value="' + $(this).prop('make_id') + '">' + $(this).prop('name') + '</option>';
								});
								make.html('<option value="0">2. - Select Make -</option>' + options);
								make.prop('disabled', false);
								model.html('<option>3. - Select Model -</option>');
								_disable(model);
							}
						},
						"json"
						);
				});
			make.change(function() {
				$('.wait_spinner2').remove();
				var make_id = $(this).val(),
                    spiner='<div class="wait_spinner2"><i class="fa fa-spinner fa-pulse fa-fw" aria-hidden="true"></i></div>';
				if (make_id == '0') {
					model.html('<option>3. - Select Model -</option>');
					_disable(model);
					_disable(fndButton);
					return (false);}
					_disable(model);
					model.html('<option>Loading...</option>');
					model.after(spiner)
					var url = 'https://www.kensunhid.com/promo_page/car_filter/get_model.php';
					$.get(
						url,
						"make_id=" + make_id,
						function(result) {
							if (result.type == 'error') {
								alert('error'); 
								return (false);
							} else {
								$('.wait_spinner2').remove();
								var options = '';
								$(result.models).each(function() {
									options += '<option value="' + $(this).prop('model_id') + '">' + $(this).prop('name') + '</option>';});
								model.html('<option value="0">3. - Select Model -</option>' + options);
								model.prop('disabled', false);
							}
						},
						"json"
						);
				});
			model.change(function() {
				var model_id = model.val();
				var url = 'https://www.kensunhid.com/promo_page/car_filter/get_hl.php';
				$.get(url,
					"model_id=" + model_id,
					function(result) {
						var outputBulbSize = jQuery.parseJSON(result);
                  var headlights ={
                    'low' : outputBulbSize.low.toUpperCase(),
                    'high' : outputBulbSize.high.toUpperCase(),
                    'fog' : outputBulbSize.fog.toUpperCase(),
                    'hl' : outputBulbSize.hl.toUpperCase()
                  },
						additionalInfo = "&name=" + $('#year_id_hero option:selected').text() + " " + $('#make_id_hero option:selected').text() + " " + $('#model_id_hero option:selected').text(),
						searchUrl= "/search?type=product&q=";
                  
                  for (var value in headlights) {
                    if ('LED(F)'===headlights[value]) {continue;}
                    if (headlights[value].length !==0) {
                    searchUrl+=headlights[value]+" OR ";
                    additionalInfo+="&" + value + "=" + headlights[value];
                    }
                  }
						searchUrl=searchUrl.slice(0, -4);
						$('.shopChoose select').val('0')
						window.open(searchUrl + additionalInfo, "_self");
					})
				});
			}
        
		}
define_car_App.init();

 }())